import { Link } from 'react-router-dom';

export default function NewsletterSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 text-primary-700 text-sm mb-5">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-mail-send-line"></i>
          </span>
          <span>保持关注</span>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          获取最新安全资讯
        </h2>
        <p className="text-sm text-foreground-500 mb-8 max-w-lg mx-auto">
          订阅我们的内容更新，第一时间获取暗网安全动态、教程更新和深度评测报告
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/latest-news"
            className="px-6 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-sm"
          >
            <i className="ri-newspaper-line mr-2"></i>
            浏览最新动态
          </Link>
          <Link
            to="/category/access-tutorial"
            className="px-6 py-3 bg-white text-foreground-800 font-medium rounded-md border border-background-200/70 hover:border-primary-300 hover:text-primary-600 transition-all duration-200 whitespace-nowrap text-sm"
          >
            <i className="ri-book-open-line mr-2"></i>
            开始学习
          </Link>
        </div>
      </div>
    </section>
  );
}